import React from 'react';
import ErrorMessage from './ErrorMessage'
import Config from '../../config';

import '../../styles/messages/CardMessage.css';
import {PreviewButton, PreviewFooter} from 'react-weui';

export default class FileMessage extends React.PureComponent {
    onDownLoadFile() {
        let lecture = this.props.lecture;
        let message = {}
        if (typeof (this.props.message.meta) === 'object' && this.props.message.meta.doc_ext) {
            message = this.props.message
            window.location.href = message.meta.doc_url
        } else {
            message = JSON.parse(this.props.message.content)
            window.location.href = Config.BASE_URL + `/api/classroom/${lecture.id}/document/${message.id}/download`;
        }
    }

    render() {
        try {
            if (typeof (this.props.message.meta) === 'object' && this.props.message.meta.doc_ext) {
                let message = this.props.message.meta
                let docExt = message.doc_ext.toLowerCase()

                return (
                    <div className="card-content">
                        <div className="file-message lecture-card" onClick={this.onDownLoadFile.bind(this)}>
                            <div className="info">
                                <div className="left-side">
                                    <div className="cover">
                                        {'txt' === docExt &&
                                        <i className="iconfont icon-TXT"/>
                                        }
                                        {['doc', 'docx'].indexOf(docExt) > -1 &&
                                        <i className="iconfont icon-docx"/>
                                        }
                                        {['ppt', 'pptx'].indexOf(docExt) > -1 &&
                                        <i className="iconfont icon-ppt"/>
                                        }
                                        {'pdf' === docExt &&
                                        <i className="iconfont icon-PDF23"/>
                                        }
                                        {['xls', 'xlsx'].indexOf(docExt) > -1 &&
                                        <i className="iconfont icon-xls1"/>
                                        }
                                    </div>
                                </div>
                                <div className="right-side">
                                    <p className="name text-ellipsis">{message.doc_name}</p>
                                    <p className="meta">
                                        <span>{message.doc_ext}</span>
                                        <span className="doc-size">{Number(message.doc_size).toFixed(2) + 'M'}</span>
                                    </p>
                                </div>
                            </div>
                            <PreviewFooter>
                                <PreviewButton primary>下载</PreviewButton>
                            </PreviewFooter>
                        </div>
                    </div>
                )
            } else {
                let message = JSON.parse(this.props.message.content);

                return (
                    <div className="card-content">
                        <div className="file-message lecture-card" onClick={this.onDownLoadFile.bind(this)}>
                            <div className="info">
                                <div className="left-side">
                                    <div className="cover"
                                         style={{backgroundImage: `url(${message.icon_url})`}}>
                                    </div>
                                </div>
                                <div className="right-side">
                                    <p className="name text-ellipsis">{message.name}</p>
                                    <p className="meta">
                                        {message.type}
                                    </p>
                                </div>
                            </div>
                            <PreviewFooter>
                                <PreviewButton primary>下载</PreviewButton>
                            </PreviewFooter>
                        </div>
                    </div>
                )
            }
        } catch(e) {
            return <ErrorMessage/>
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/messages/FileMessage.js